import styled, { css } from 'styled-components/native';
import { themes } from '../../design/colors';
import {
  Feather as IconsFE,
  FontAwesome5 as IconsFA5,
} from "@expo/vector-icons";

interface ContainerProps {
  color?: string
}

export const Container = styled.TouchableOpacity<ContainerProps>`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color ?? themes.colors.primary};
`;

export const IconFE = styled(IconsFE)``;